









































import { Component, Vue } from "vue-property-decorator";
import {Action} from "vuex-class";
import {notifyError} from "@/utils/notify-helper";
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";
import {EmailDetailEventsInfo} from "@/store/email/statistic/types";
import {InputWings} from "wings-ui-components";

@Component({components: {InputWings}})
export default class EmailEventsDetailInfo extends Vue {
  @Action("getEmailDetailEventsInfo") actionGetDetailInfo: any;
  @Action("actionLog") actionLog: any;

  logObject: ActionLog = {};
  messageInfo: EmailDetailEventsInfo = {date: null, type: null};

  async created() {
    if (this.$route.params.id) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: 'success',
          object_type: "Event",
          addititional_info: getTranslatedParams({id: this.$route.params.id})
        }
        const resp = await this.actionGetDetailInfo({message_id: this.$route.params.message_id, id: this.$route.params.id});
        await this.actionLog(this.logObject);
        this.messageInfo = Object.assign({}, this.messageInfo, resp.data);
      } catch(error) {
        await this.actionLog({...this.logObject, actionStatus: 'failed'})
        notifyError(error);
      }
    }
  }

  get messageId(): string {
    return this.$route.params.id;
  }

  back(): void {
    this.$router.back();
  }
}
